import React from "react"
import {observer} from "mobx-react"
import {injectIntl, FormattedMessage} from "react-intl"
import Grid from "@material-ui/core/Grid"
import {withStyles} from "@material-ui/core/styles"
import InvoiceListStore from "../../../stores/InvoiceListStore"
import GenerateInvoiceFromServiceDialogStore from "../../../stores/GenerateInvoiceFromServiceDialogStore"
import UIStore from "../../../stores/UIStore"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import bindings from "../../../../../global/ui/globalUISchemeBindings"
import fields from "./invoiceFilterFields"

import moment from "moment"
import XsInput from "../../../../../global/ui/xsInput/xsInput"
import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
import InvoiceForm from "./invoiceForm/invoiceForm"
import XsLoading from "../../../../../global/ui/xsLoading/xsLoading"
import {priceToSKPrice} from "../../../../../global/helpers/functions"
import XsTableServer from "../../../../../global/ui/xsTableServer/xsTableServer"
import api from "../../../actions/api"
import GenerateInvoiceFromServiceDialog from "../generateInvoiceFromServiceDialog/generateInvoiceFromServiceDialog"
import ExportInvoicesPDFDialog from "./exportInvoicesPDFDialog"
import ExportInvoicesDialog from "./exportInvoicesDialog"
import InvoiceFormStore from "../../../stores/InvoiceFormStore"
import XsCheckbox from "../../../../../global/ui/xsCheckbox/xsCheckbox"
import InvoiceListAction from "./invoiceListAction"
import XsSearchSelect from "../../../../../global/ui/xsSearchSelect/xsSearchSelect"
import TableStore from "../../../stores/TableStore"

const styles = () => ({
	searchIcon: {
		marginTop: "14px"
	}
})

@withStyles(styles)
@injectIntl
@observer
export default class InvoiceList extends React.Component {
	constructor(props) {
		super(props)
		UIStore.isFormSaving = false
		InvoiceListStore.checkedInvoces = []

		//Load odberateľov
		InvoiceFormStore.loadCustomers()

		const hooks = {
			onSubmit() {},
			onSuccess(form) {
				if (
					isNotEmpty("invoiceList") &&
					TableStore.tables.hasOwnProperty("invoiceList") &&
					TableStore.tables["invoiceList"].hasOwnProperty("index")
				) {
					delete TableStore.tables["invoiceList"]["index"]
				}

				InvoiceFormStore.getInvoiceFilters(form)
			},
			onError() {}
		}

		if (isEmpty(InvoiceFormStore.formRef)) {
			InvoiceFormStore.formRef = new MobxReactForm(fields.load(), {plugins: {dvr: validatorjs}, hooks, bindings})
		}

		this.form = InvoiceFormStore.formRef

		InvoiceFormStore.getInvoiceFilters(this.form)
	}

	onHandleRowClick = (dataRow) => {
		InvoiceListStore.set("selectedInvoiceID", dataRow.id)
		InvoiceListStore.set("showForm", true)
	}

	onHandleNewButtonClick = () => {
		InvoiceListStore.set("selectedInvoiceID", null)
		InvoiceListStore.set("showForm", true)
	}

	componentWillUnmount() {
		InvoiceListStore.reset()
	}

	getFilterHeader() {
		InvoiceFormStore.isChangedFilter(this.form.values())

		return (
			<Grid item xs container spacing={8} alignItems="center">
				<Grid item xs={3}>
					<XsInput white field={this.form.$("invoice_number")} />
				</Grid>
				<Grid item xs={4}>
					<XsSearchSelect white field={this.form.$("customer")} items={InvoiceFormStore.customers} />
				</Grid>
				<Grid item className="pb-0">
					<XsCheckbox field={this.form.$("actualOrgUnit")} />
				</Grid>
				<Grid item className="pb-0">
					<XsIconButton
						rect
						tooltip={this.props.intl.formatMessage({id: "Common.label.applyFilter"})}
						className="xs-default xs-outline"
						onClick={this.form.onSubmit}
						icon={<i className="far fa-search fa-lg xs-greyDefault"></i>}
					/>
				</Grid>
			</Grid>
		)
	}

	render() {
		const applyFilters = InvoiceFormStore.filters
		const dateFormat = this.props.intl.formatMessage({id: "Application.moment.dateformat"})

		return (
			<React.Fragment>
				<Grid container spacing={16}>
					{InvoiceListStore.showForm && <InvoiceForm invoiceID={InvoiceListStore.selectedInvoiceID} />}
					{!InvoiceListStore.showForm && (
						<React.Fragment>
							<Grid item container justify="space-between" alignItems="center">
								{this.getFilterHeader()}
								<InvoiceListAction />
							</Grid>
							{InvoiceFormStore.changedFilters ? (
								<Grid item xs={12} className="xs-table-no-data pa-3 borderRadius-1 mt-8">
									<i className="far fa-search fa-lg mr-3 pointer" onClick={this.form.onSubmit}></i>
									<FormattedMessage id="Common.label.changeFilterSettingsClkickOnTheMagnifyingToApplyThem" />
								</Grid>
							) : (
								<Grid item xs={12}>
									<XsTableServer
										setRef={(table) => (InvoiceListStore.tableRef = table)}
										uri={`${api.loadInvoices().getPath()}`}
										filterValue={applyFilters}
										config={{
											columnDefs: {
												typeNameExt: {
													title: <FormattedMessage id="Delivery.List.Type" />,
													type: "string",
													design: {
														width: "10%"
													},
													sortable: true,
													dbName: "type.name_ext"
												},
												number: {
													title: <FormattedMessage id="Invoice.form.number" />,
													type: "string",
													design: {
														width: "10%"
													},
													sortable: true,
													dbName: "invoice_number"
												},
												customer: {
													title: <FormattedMessage id="Invoice.form.customer" />,
													type: "string",
													design: {
														width: "20%"
													},
													sortable: true,
													dbName: "customer.name"
												},
												customername: {
													title: <FormattedMessage id="Invoice.form.customername" />,
													type: "string",
													design: {
														width: "15%"
													},
													sortable: true,
													dbName: "customer_data.name"
												},
												issuedate: {
													title: <FormattedMessage id="Invoice.form.issuedate" />,
													type: "datetime",
													design: {
														width: "10%",
														body: {
															formatter: (props) => {
																return isSafe(props) && isNotEmpty(props) ? moment(props).format(dateFormat) : ""
															}
														}
													},
													sortable: true,
													dbName: "issue_date"
												},
												duedate: {
													title: <FormattedMessage id="Invoice.form.duedate" />,
													type: "datetime",
													design: {
														width: "10%",
														body: {
															formatter: (props) => {
																return isSafe(props) && isNotEmpty(props) ? moment(props).format(dateFormat) : ""
															}
														}
													},
													sortable: true,
													dbName: "due_date"
												},
												totalcost: {
													title: <FormattedMessage id="Invoice.form.totalcost" />,
													type: "string",
													design: {
														width: "10%",
														header: {
															className: "xs-text-align-right"
														},
														body: {
															className: "textRight",
															formatter: (props) => {
																return priceToSKPrice(props)
															}
														}
													},
													sortable: true,
													dbName: "total_cost"
												},
												period: {
													title: <FormattedMessage id="Patient.labels.period" />,
													type: "datetime",
													design: {
														width: "10%"
													}
												},
												master_invoices: {
													title: "Z faktúry",
													type: "action",
													design: {
														width: "12%",
														body: {
															renderer: (props) => {
																let masters = props.value.map((x, idx) => {
																	return (
																		<span key={idx} onClick={() => this.onHandleRowClick({id: x.master._id})}>
																			{x.master.invoice_number}
																		</span>
																	)
																})

																return <span className="xs-bold pointer blueDark">{masters}</span>
															}
														}
													}
												}
											},
											options: {
												checkboxes: true,
												checkboxColumn: "id",
												onClickCheckbox: (data) => {
													InvoiceListStore.checkedInvoces = data
												},
												name: "invoiceList",
												showCursor: true,
												onRowClick: (dataRow) => {
													this.onHandleRowClick(dataRow)
												},
												mapper: (dataRow) => {
													return {
														id: dataRow._id,
														typeNameExt: dataRow.type.name_ext,
														number: dataRow.invoice_number,
														customer: isSafe(dataRow.customer) ? dataRow.customer.name_ext : "",
														customername: isSafe(dataRow.customer_data) ? dataRow.customer_data.name : "",
														issuedate: isSafe(dataRow.issue_date) ? dataRow.issue_date : "",
														duedate: isSafe(dataRow.due_date) ? dataRow.due_date : "",
														totalcost: isSafe(dataRow.total_cost) ? `${dataRow.total_cost} €` : "",
														period: isSafe(dataRow.period) ? dataRow.period : "",
														master_invoices:
															isSafe(dataRow.master_invoices) && dataRow.master_invoices
																? dataRow.master_invoices
																: null
													}
												}
											}
										}}
									/>
								</Grid>
							)}
						</React.Fragment>
					)}
					{UIStore.isFormSaving && <XsLoading overlay={false} />}
				</Grid>
				{GenerateInvoiceFromServiceDialogStore.isOpen && <GenerateInvoiceFromServiceDialog />}
				<ExportInvoicesPDFDialog />
				<ExportInvoicesDialog />
			</React.Fragment>
		)
	}
}
